import React from 'react';
import {  Grid, Box, TableFooter, Button, Typography, Paper, Link } from '@material-ui/core';
import SingleTransferBody from './SingleTransferBody';
import SingleTransferHeaderOptions from './SingleTransferHeaderOptions';
import { isEmpty } from 'lodash-es';

const SingleTransferTemplate = (props) => {

    const {shop, transfer, children, handleInstallToSale, handleCompleteArrivage, handleUpdateArrivage, handleUpdateDemand,handleUpdatePurchase, handleUpdateRea} = props;
    console.log('================TRANSFER====================');
    console.log({transfer});
    console.log('====================================');
    return(
        <Paper elevation={0}>
            {!isEmpty(transfer) &&
            <>
                <SingleTransferHeaderOptions
                    shop={shop}
                    transfer={transfer}
                    {...props}
                />    
                
                <SingleTransferBody 
                    {...props}
                    handleInstallToSale={handleInstallToSale}
                    handleCompleteArrivage={handleCompleteArrivage}  
                    handleUpdateArrivage={handleUpdateArrivage}  
                    handleUpdateDemand={handleUpdateDemand}
                    handleUpdatePurchase={handleUpdatePurchase}  
                    handleUpdateRea={handleUpdateRea}  
                    shop={shop}
                    transfer={transfer}
                    children={children}
                />
                {shop && transfer.nature != "achat" && transfer.nature != "reservation" &&
                    <SingleFooterTemplate shop={shop}/>
                }
                </>
            }
        </Paper>
    );
}


export default SingleTransferTemplate;

export const  SingleFooterTemplate = ({shop}) => {
    return (
        <Box p={1} className="footer text-center">
            <Box><Typography variant="caption" className="bottom-info">{shop.bottom_info}</Typography></Box>
            <Box><Typography variant="caption" className="bottom-info">{shop.bottom_info2}</Typography></Box>
            <Box><Typography variant="caption" className="bottom-info">{shop.bottom_info3}</Typography></Box>
        </Box>
    );
    
}
